import { ActionEnum } from '../action.enum';
import {
  ChecklistTemplateVersionEntryFilterResultsModel, ChecklistTemplateVersionEntryInputUpdate
} from '../../models/checklist-template/checklist-template-version-entry-filter-results.model';


export namespace ChecklistTemplateEntryInputQuickSettingsDialogAction {
  export class Init {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_ENTRY_INPUT_QUICK_SETTINGS_DIALOG_INIT;

    constructor(public entryWithInputs: ChecklistTemplateVersionEntryFilterResultsModel) {}
  }

  export class ChangeValue{
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_ENTRY_INPUT_QUICK_SETTINGS_DIALOG_CHANGE_VALUE;

    constructor(public updateDto: ChecklistTemplateVersionEntryInputUpdate) {
    }
  }

  export class Save {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_ENTRY_INPUT_QUICK_SETTINGS_DIALOG_SAVE;
  }

  export class Reset {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_ENTRY_INPUT_QUICK_SETTINGS_DIALOG_RESET;
  }
}
